module.exports = __webpack_public_path__ + "img/user.b22a9618.png";